export default class ShopFilters extends HTMLElement {
    sortBy: string
    type: string

    sortByEl: HTMLInputElement
    typeEl: HTMLInputElement
    form: HTMLFormElement

    constructor() {
        super()

        this.sortBy = this.getAttribute('sort_by') || ''
        this.type = this.getAttribute('filter') || ''

        this.sortByEl = this.querySelector('[name="sort_by"]') as HTMLInputElement
        this.typeEl = this.querySelector('[name="filter"]') as HTMLInputElement
        this.form = this.querySelector('form') as HTMLFormElement

        this.form.addEventListener('change', this.handleChange.bind(this))
    }

    handleChange(evt: Event) {
        const target = evt.target as HTMLInputElement
        const searchParams = new URLSearchParams(window.location.search)

        if (target.value && target.value !== 'all') {
            searchParams.set(target.name, target.value)
        } else {
            searchParams.delete(target.name)
        }

        // Update the URL without refreshing the page
        const newUrl = `${window.location.pathname}?${searchParams.toString()}`

        window.history.pushState({ path: newUrl }, '', newUrl)

        // Reload the page
        window.location.reload()
    }
}

customElements.define('shop-filters', ShopFilters)
